import { css } from 'linaria';

// HACK: Удалить !important после фикса NAVI-4853
export const MobileSnackbarClassName = css`
  @media (--only-mobile) {
    bottom: 51px !important;
    padding-bottom: 0 !important;
  }
`;
